import { useEffect, useState } from 'react';

import { getStatisticsImg, getStatisticsUrlForExternalContent } from '../../../../utils';

import { PATH, RESOURCES } from '../../../../constants';

String.prototype.replaceHrefPrefix = function () {
    return this.replace(/mfxanswer:/g, `${PATH.helpAndSupport}/`);
};
String.prototype.replaceResourcePrefix = function () {
    return this.replace(/mfxresource:/g, `${RESOURCES.url}/`);
};

const Content = ({ content }) => {
    const [statisticsImg, setStatisticsImg] = useState(null);

    useEffect(() => {
        const enableStatisticsLoggingManyTimesForTheSameUrl = () => {
            if (statisticsImg) {
                setStatisticsImg(null);
            }
        };

        enableStatisticsLoggingManyTimesForTheSameUrl();
    }, [statisticsImg]);

    if (!content) {
        return null;
    }

    const handleScrollWheelClick = (e) => {
        if (e.button !== 1) {
            return;
        }

        handleClick(e);
    };

    const handleClick = (e) => {
        if (!e?.target === 'a') {
            return;
        }

        const href = e?.target?.href;
        if (!href) {
            return;
        }

        e.preventDefault();
        const statisticsUrl = getStatisticsUrlForExternalContent(href);
        setStatisticsImg(getStatisticsImg(statisticsUrl));
        window.open(href, '_blank', 'noreferrer');
    };

    const sanitisedContent = content
        .replaceHrefPrefix()
        .replaceResourcePrefix();

    return (
        <>
            {statisticsImg}
            <div
                data-cy="content-element"
                dangerouslySetInnerHTML={{ __html: sanitisedContent }}
                onClick={handleClick}
                onAuxClick={handleScrollWheelClick}
            />
        </>
    );
};

export default Content;
